import React from 'react';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

const TimelineDeleteConfirmation = ({ open, busy, error, onCancel, onConfirm, title = 'Delete entry?', confirmLabel = 'Delete entry', message = 'This entry will be removed from Timeline.' }) => (
  <Dialog open={open} onClose={busy ? undefined : onCancel} aria-labelledby="timeline-delete-title" fullWidth maxWidth="xs">
    <DialogTitle id="timeline-delete-title">{title}</DialogTitle>
    <DialogContent>
      <DialogContentText>{message}</DialogContentText>
      {error ? <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert> : null}
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} disabled={busy}>Cancel</Button>
      <Button onClick={onConfirm} disabled={busy} color="error" variant="contained">
        {busy ? 'Deleting…' : confirmLabel}
      </Button>
    </DialogActions>
  </Dialog>
);

export default TimelineDeleteConfirmation;
